import DashboardService from "app/components/dashboard/services/DashboardService";
import { i18nFilter } from "app/filters/i18nFilter";
import { ConnectedDashboardWelcome } from "app/pages/dashboard/DashboardWelcome";
import type { FC } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { SwTrack } from "app/services/SwTrack";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const DashboardParentContainer = styled.div`
    overflow-y: auto;
    height: 100%;
    overflow-x: hidden;
    flex-grow: 1;
    position: relative;
`;
DashboardParentContainer.displayName = "DashboardParentContainer";

export const DashboardEmptyPageV2: FC = () => {
    const title = i18nFilter()("home.dashboards.title");
    const subtitle = i18nFilter()("home.dashboards.subtitle");
    const buttonText = i18nFilter()("home.dashboards.button");

    useEffect(() => {
        if (DashboardService.dashboards.length > 0) {
            proNavigator.go("dashboard-exist", {
                dashboardId: DashboardService.dashboards[0].id,
            });
        }
    }, []);

    function onCTAClick() {
        SwTrack.all.trackEvent("Internal Link", "click", "First dashboard");
        proNavigator.go("dashboard-gallery");
    }

    return (
        <div className="contentWrap dashboardCreate">
            <ConnectedDashboardWelcome
                title={title}
                subtitle={subtitle}
                onCTAClick={onCTAClick}
                buttonText={buttonText}
            />
        </div>
    );
};
